import { ImageCarousel } from '../../components/carousel/image-carousel';
import {  Tabs } from '../../components/tabs/tabs';
import { ProfileSection } from '../../components/containers/profile-section';
import { GoogleReviews } from '../../components/carousel/google-review-carousel';
import { VerifiedCard } from '../../components/cards/verified-card';
import { ContactCard } from '../../components/cards/contact-card';
import { WorkHoursCard } from '../../components/cards/work-hours-card';
import { MapCard } from '../../components/cards/map-card';
import { useServiceByIdViewModel } from './service-by-id.view-model';
import { ServiceByIdSkeleton } from '../../components/skeletons/service-by-id.skeleton';
import { TagContainer } from '../../components/containers/tag-container';
import { FloatingCallButton } from '../../components/floatings/floating-call';


export const ServiceByIdPage = () => {

  const {tabs, activeTab, gallery
    , refs, onTabChange, facilities, reviews, isLoading, service, activities, serviceName} =  useServiceByIdViewModel()

  const phoneNumber =  service?.contacts?.[0] ?? '112';

  const location = service?.address?.[0]?.route ?? ''


  if (isLoading) {
    return  <ServiceByIdSkeleton/>
  }
  const mapId =  service.address.find((item)=>item.mapId)?.mapId

  return (<div className={'mb-4'}>
    { gallery.length > 0 && <ImageCarousel gallery={gallery}/> }
     <div className={'pt-4'}>
      <VerifiedCard rating={service?.rating?.rating ?? 0} verified={service.verified}/>
      <h1 className="font-manrope font-semibold leading-[25px] color-#1D2126 text-[25px] pt-1">
        {service.name}
      </h1>
    </div>

     <div className={'pt-6 pb-2'} ref={refs.tabsRef}>
    <Tabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange}/>
     </div>
    { activities.length > 0 && (
    <ProfileSection className="w-full max-w-none mt-2 mb-4" >
      <h2 className="text-lg font-semibold text-gray-900 mb-4" ref={refs.descriptionRef}>Servicii</h2>
      <TagContainer items={activities} className={'h-6 w-6'}/>
    </ProfileSection>
    )}
    { facilities.length > 0 && (
    <ProfileSection className={'w-full max-w-none mt-4 mb-4'}>
      <h2 className="text-lg font-semibold text-gray-900 mb-3">Comodități</h2>
        <TagContainer items={facilities} className={'text-xs'}/>
    </ProfileSection>
    )}
    {/*<ProfileSection className="w-full max-w-none mb-4">*/}
    {/*  <h2 className="text-lg font-semibold text-gray-900 mb-4">Oferte și reduceri </h2>*/}
    {/*</ProfileSection>*/}

    { reviews.length > 0 && (
      <ProfileSection className={'w-full max-w-none mt-4 mb-4'}>
        <h2 className="text-lg font-semibold text-gray-900 mb-1" ref={refs.reviewsRef}>Recenzii</h2>
        <GoogleReviews reviews={service.rating} isLoading={isLoading}/>
      </ProfileSection>
    )}


    <div className="flex flex-col md:flex-row w-full gap-4" ref={refs.contactRef}>
      <ProfileSection className="flex flex-col w-full md:w-1/2">
        <h2 className="text-lg font-semibold text-gray-900 mb-3">Contacte</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {
            service.contacts.map((contact, index) => <ContactCard key={index} contact={contact}/>)
          }
        </div>
      </ProfileSection>

      <ProfileSection className="flex flex-col w-full md:w-1/2">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Orele de lucru</h2>
        <WorkHoursCard workHours={service.workHours} address={service.address} />
        </ProfileSection>
    </div>

    <ProfileSection className={'w-full max-w-none mt-4 mb-4"'}>
      <h2 className="text-lg font-semibold text-gray-900">Harta</h2>
      <p>Vezi direcțile către {serviceName}</p>
      <MapCard mapId={mapId}/>
    </ProfileSection>

    <FloatingCallButton
      phoneNumber={phoneNumber}
      location={location}
    />

  </div>)
}